import React, { useState, useEffect } from "react";
import {
  Container,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Button,
  Select,
  MenuItem,
  Typography,
  IconButton,
  InputLabel,
  FormControl,
  Tooltip,
  Box,
  TableSortLabel,
  TextField,
  Checkbox,
  Menu,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";
import { checkStyle } from "../../services/CommonService";
import { useNavigate } from "react-router-dom";
import { SERVICE_ADVISORY_LISTING_COLUMNS } from "../../utils/constant";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import RecordNotFound from "../../common/RecordNotFound";
import SearchIcon from "@mui/icons-material/Search";
import { useForm } from "react-hook-form";
import UploadServiceAdvisory from "./UploadServiceAdvisory";
import moment from "moment";
import { visuallyHidden } from "@mui/utils";
import FilterAltOffSharpIcon from "@mui/icons-material/FilterAltOffSharp";
import {
  DownloadServiceAdvisoryService,
  ChangeServicAdvStatusService,
  getModelandDeptDetailAdvService,
  deleteServiceAdvisoryService
} from "../../services/ServiceAdvisoryService";
import useGlobalState from "../../Context";
import download from "downloadjs";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import MoreVertIcon from "@mui/icons-material/MoreVert";

export default function ServiceAdvisoryList({
  handleTableChanges,
  totalElements,
  techDocumentRecords,
  setTechDocumentRecords,
  setLoading,
  showNotification,
  fetchBrandListOnSelectedBrick,
  onSearchServiceAdvisoryDetails,
  UploadServiceAdvisoryDetails,
  UpdateServiceAdvisoryDetails,
  fetchAllBrandsList,
  fetchModelsList,
  modelList,
  allBrands,
  modelDescription,
  fetchModelDescriptionOnSelectedModel,
  fetchModelsDeptList,
  fetchBrickListOnSelectedBrandForUpload,
  brickListForUpload,
  fetchServiceAdvisoryDetails,
  state,
  noRecord,
  setModelDescription,
  brickList,
  fetchBrickListWithorWithoutFamily,
  fetchCategoryListOnSelectedBrand,
  fetchProductFamilyList,
  productFamilyList,
  categoryListOnBrandId,
  docTypeList,
  fetchDocTypeList,
  departmentList,
  brandDropDownList,
  fetchBrandSearchDropdownList,
  fetchCatSearchDropdownList,
  fetchFamSearchDropdownList,
  fetchBrickSearchDropdownList,
  categoryList,
  familyList,
  brickDropdownList,
  modelIdData,
  deptIdData,
  selectedModelIds,
  selectedDeptIds,
  setSelectedModelIds,
  setSelectedDeptlIds,
  setModelIdData,
  setDeptIdData,
  loadAllFiles,
  existingFiles,
  setExistingFiles
}) {
  const [nameSearch, setNameSearch] = useState(null);
  const [page, setPage] = useState(0);
  const [maxPage, setMaxPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [searchModelNameValue, setSearchModelNameValue] = useState("");
  const [brickSearch, setBrickSearch] = useState(null);
  const [searchedRows, setSearchedRows] = useState(techDocumentRecords);
  const [file, setFile] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [releaseDate, setReleaseDate] = useState(null);
  const [brandId, setBrandId] = useState(null);
  const [modelId, setModelId] = useState(null);
  const [sortValue, setSortValue] = useState(null);
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("advisoryNumber");
  const [formData, setFormData] = useState({});
  const [disableFilterButton, setdisableFilterButton] = useState(true);
  const [disableSearchButton, setDisableSearchButton] = useState(true);
  const [disableBrickDropdown, setDisableBrickDropdown] = useState(true);
  const [disableModelDropdown, setDisableModelDropdown] = useState(true);
  const [multiModelId, setMultiModelId] = useState();
  const [disableUpdateButton, setDisbaleUpdateButton] = useState(true);
  const [{ auth, advisoriesAccessRights }, dispatch] = useGlobalState();
  const loginParam = auth.ldapParam;
  const [sendNotification, setSendNotification] = React.useState(false);
  const [isSearchBtnClick, setIsSearchBtnClick] = useState(false);
  const [draftCheck, setDraftCheck] = useState(false);
  const [selected, setSelected] = useState([]);
  const [isAddServAdv, setIsAddServAdv] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const loginUserId = auth.ldapParam.userId;
  const userDept = auth.ldapParam.deptId;
  const [disableCategoryDropdown, setDisableCategoryDropdown] = useState(true);
  const [disableFamilyDropdown, setDisableFamilyDropdown] = useState(true);
  const [familyName, setFamilyName] = useState("");
  const [brandSearch, setBrandSearch] = useState(null);
  const [categorySearch, setCategorySearch] = useState(null);
  const [familySearch, setFamilySearch] = useState(null);
  const [typeSearch, setTypeSearch] = useState(null);
  const [modelSearchValue, setModelNameSearch] = useState(null);
  const [techDocSearch, setTechDocSearch] = useState(null);
  const [techDocNameSearch, setTechDocNameSearch] = useState(null);
  const [currentError, setCurrentError] = useState(null);
  const [errorDate, setErrorDate] = useState(false);
  const [brandSearch_, setbrandSearch_] = useState(null);
  const [categorySearch_, setcategorySearch_] = useState(null);
  const [familySearch_, setfamilySearch_] = useState(null);
  const [brickSearch_, setbrickSearch_] = useState(null);
  const [typeSearch_, settypeSearch_] = useState(null);
  const [modelSearchValue_, setmodelSearchValue_] = useState(null);
  const [techDocSearch_, settechDocSearch_] = useState(null);
  const [formValues, setFormValues] = useState({
    createdOn: new Date(),
    createdBy: loginUserId,
    active: 1,
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRowForMenu, setSelectedRowForMenu] = useState(null);
  const open = Boolean(anchorEl);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);

  const filesFormats = ["doc", "docx", "pdf", "ppt", "csv", "pptx", "xlsx", "xls"];
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors, isTouched, isDirty },
    setValue,
    reset,
    clearErrors,
  } = useForm();

  useEffect(() => {
    setFile(null);
    reset(formData);

    setModelDescription("");
    setSendNotification(false);
  }, [openDialog]);

  useEffect(() => {

    const selectedRows =
      techDocumentRecords &&
      techDocumentRecords.filter(
        (row) =>
          row.name
            .toUpperCase()
            .includes(nameSearch && nameSearch.toUpperCase()) ||
          row.name.toUpperCase()
      );
    setSearchedRows(selectedRows);
    if (state) {
      setOrderBy("");
    }
  }, [nameSearch, techDocumentRecords]);

  const onBrandSelectedClick = async (id, name) => {
    setDisableCategoryDropdown(false);
    setDisableFamilyDropdown(true);
    setDisableBrickDropdown(true);
    setDisableModelDropdown(true);
    await fetchCategoryListOnSelectedBrand(id);
    setBrandId(id);
  };

  const onCategoryClickInModel = async (id, cateName) => {
    setDisableFamilyDropdown(false);
    setDisableBrickDropdown(true);
    setDisableModelDropdown(true);
    setValue("productCatFamilyMappingId", "");
    setValue("brickId", "");
    //setDisableSearchButton(false);
    // setdisableFilterButton(false);
    await fetchProductFamilyList(id);
  };
  const onFamilyClick = async (id, name) => {
    setFamilyName(name);
    setDisableBrickDropdown(false);
    setDisableModelDropdown(true);
    await fetchBrickListWithorWithoutFamily(id);
  };
  const onTypeClick = (id) => {
    setTypeSearch(id);
    setDisableSearchButton(false);
    setdisableFilterButton(false);
  };

  const handleMenuClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowForMenu(row);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setSelectedRowForMenu(null);
  };

  const openDeleteConfirm = (row) => {
    setRowToDelete(row);
    setConfirmDeleteOpen(true);
  };

  const handleCloseDeleteConfirm = () => {
    setConfirmDeleteOpen(false);
    setRowToDelete(null);
  };

  const handleDeleteAdvisory = async (row) => {
    try {
      setLoading(true);
      const payload = {
        advisoryNumber: row.advisoryNumber,      
        userId: auth.ldapParam.userId,      
      };
      const res = await deleteServiceAdvisoryService(payload);

      if (res?.statusCode === 6) {
        showNotification(
          "Success",
          res?.message ?? "Service advisory deleted successfully",
          "success"
        );
        // refresh list as per your existing pattern
        onClearClick && onClearClick();
      } else {
        showNotification(
          "Error",
          res?.message ?? "Failed to delete service advisory",
          "error"
        );
      }
    } catch (err) {
      showNotification(
        "Error",
        err?.message ?? "Failed to delete service advisory",
        "error"
      );
    } finally {
      setLoading(false);
      setConfirmDeleteOpen(false);
      setRowToDelete(null);
    }
  };

  const handleMenuItem = (action) => {
    if (!selectedRowForMenu) return;

    switch (action) {
      case "edit":
        handleClickEditServAdv(selectedRowForMenu);
        break;
      case "download":
        handleDownload(selectedRowForMenu.id);
        break;
      case "delete":
        openDeleteConfirm(selectedRowForMenu);
        break;
      default:
        break;
    }
    handleCloseMenu();
  };

  const handleChangeRowsPerPage = async (event) => {
    const paginationValues = {
      pageNumber: 0,
      pageSize: +event.target.value,
    };
    await handleTableChanges(
      paginationValues,
      false,
      sortValue,
      orderBy,
      brandSearch_, categorySearch_, familySearch_, brickSearch_, typeSearch_, modelSearchValue_, techDocSearch_
    );
    setPage(0);
    setMaxPage(0);
    setRowsPerPage(+event.target.value);
  };



  const handleActiveChange = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
    if (newSelected.length !== 0) {
      setDisbaleUpdateButton(false);
    } else {
      setDisbaleUpdateButton(true);
    }
    const newSearchedRow = techDocumentRecords.map((currentRow) => {
      if (currentRow.id === id) {
        return {
          ...currentRow,
          isActive: event.target.checked,
        };
      }
      return currentRow;
    });
    setTechDocumentRecords(newSearchedRow);
  };

  const handleChangePage = async (event, newPage) => {
    if (newPage > page && newPage > maxPage) {
      setMaxPage(newPage);
      const paginationValues = {
        pageNumber: newPage,
        pageSize: rowsPerPage,
      };
      await handleTableChanges(
        paginationValues,
        true,
        sortValue,
        orderBy,
        brandSearch_, categorySearch_, familySearch_, brickSearch_, typeSearch_, modelSearchValue_, techDocSearch_
      );
    }
    setPage(newPage);
  };
  const goBack = () => {
    navigate("/notifications");
  };
  const searchText = async (e) => {
    setModelNameSearch(e.target.value);

    if (e.target.value === "" && brandSearch === null && categorySearch === null && familySearch === null && brickSearch === null && typeSearch === null && !techDocSearch) {
      onClearClick()
      // await fetchServiceAdvisoryDetails("advisoryNumber", true);
      // setPage(0);
      // setMaxPage(0);
      // setDisableSearchButton(true);
      // setdisableFilterButton(true);
    } else {
      setDisableSearchButton(false);
      setdisableFilterButton(false);
    }
    setNameSearch(null);
  };

  const searchTechDocText = async (e) => {
    setTechDocSearch(e.target.value);

    if (e.target.value === "" && brandSearch === null && categorySearch === null && familySearch === null && brickSearch === null && typeSearch === null && !modelSearchValue) {
      onClearClick()
    } else {
      setDisableSearchButton(false);
      setdisableFilterButton(false);
    }
    setTechDocNameSearch(null);

  };
  const onBrandClick = (id) => {
    fetchCatSearchDropdownList(id, brickSearch, familySearch, categorySearch);
    fetchFamSearchDropdownList(id, brickSearch, familySearch, categorySearch);
    fetchBrickSearchDropdownList(id, brickSearch, familySearch, categorySearch);
    setBrandSearch(id);
    setDisableSearchButton(false);
    setdisableFilterButton(false);
  };
  const onCategoryClick = (id) => {
    fetchBrandSearchDropdownList(brandSearch, brickSearch, familySearch, id);
    fetchFamSearchDropdownList(brandSearch, brickSearch, familySearch, id);
    fetchBrickSearchDropdownList(brandSearch, brickSearch, familySearch, id);
    setCategorySearch(id);
    setDisableSearchButton(false);
    setdisableFilterButton(false);
  };
  const onFamilySerachClick = (id) => {
    fetchBrandSearchDropdownList(brandSearch, brickSearch, id, categorySearch);
    fetchCatSearchDropdownList(brandSearch, brickSearch, id, categorySearch);
    fetchBrickSearchDropdownList(brandSearch, brickSearch, id, categorySearch);
    setFamilySearch(id);
    setDisableSearchButton(false);
    setdisableFilterButton(false);
  };
  const onBrickSearchClick = (id) => {
    fetchBrandSearchDropdownList(brandSearch, id, familySearch, categorySearch);
    fetchCatSearchDropdownList(brandSearch, id, familySearch, categorySearch);
    fetchFamSearchDropdownList(brandSearch, id, familySearch, categorySearch);
    setBrickSearch(id);
    setDisableSearchButton(false);
    setdisableFilterButton(false);
  };
  const onBrickClick = (id) => {
    setBrickSearch(id);
    fetchBrandListOnSelectedBrick(id);
    setDisableSearchButton(false);
    setdisableFilterButton(false);
  };

  const searchOnClick = async (type) => {
    try {
      setLoading(true);
      const requestBody = {
        brandId: brandSearch,
        categoryId: categorySearch,
        docTypeId: typeSearch,
        modelName: modelSearchValue && modelSearchValue.trim(),
        productFamilyId: familySearch,
        brickId: brickSearch,
        advisoryNumber: techDocSearch && techDocSearch.trim(),
        deptId: auth.ldapParam.deptId,
        userType: auth.ldapParam.userType,
        pageNumber: 0,
        pageSize: rowsPerPage ?? 10,
      };
      setbrandSearch_(brandSearch);
      setcategorySearch_(categorySearch);
      setfamilySearch_(familySearch);
      setbrickSearch_(brickSearch);
      settypeSearch_(typeSearch);
      setmodelSearchValue_(modelSearchValue);
      settechDocSearch_(techDocSearch);

      setIsSearchBtnClick(true)
      setSelected([]);
      setDisbaleUpdateButton(true)
      await onSearchServiceAdvisoryDetails(requestBody);
      setPage(0);
      setMaxPage(0);
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
  };

  const onChangeStatusSubmit = async () => {
    const resultRecords = [];
    selected.forEach((itemId) => {
      const tempItem = techDocumentRecords.find(
        (record) => record.id === itemId
      );
      if (tempItem) {
        resultRecords.push({
          active: tempItem.isActive,
          id: tempItem.id,
        });
      }
    });
    try {
      const res = await ChangeServicAdvStatusService(resultRecords);
      if (res.statusCode == "6") {
        setSelected([]);
        showNotification("Success", res.message, "success");
        setDisbaleUpdateButton(true);
      } else {
        showNotification("Error", res.message, "error");
      }
    } catch (e) {
    } finally {
    }
  };

  const handleClickEditServAdv = (item) => {
    setExistingFiles([]);
    if (item) {
      reset(item);
    }
    if (item.isSelect) {
      setIsAddServAdv(!isAddServAdv);
    } else {
      setIsAddServAdv(false);
    }
    if (item.isDrafted) {
      setDraftCheck(item.isDrafted);
      setReleaseDate(null);
    }
    else {
      setDraftCheck(false);
      setReleaseDate(item.releaseDate);
    }
    loadAllFiles(item.id).then((response) => {
      fetchModelsDeptList(item.brickId, item.brandId, item.advisoryNumber).then((response) => {
        setIsEditMode(true);
        setBrandId(item?.brandId);
        fetchAllBrandsList();
        fetchBrickListOnSelectedBrandForUpload(item.brandId);
        fetchDocTypeList();
        fetchCategoryListOnSelectedBrand(item.brandId);
        fetchProductFamilyList(item.categoryId);
        fetchBrickListWithorWithoutFamily(item.productFamilyId);
        setFormValues({
          createdOn: item?.createdOn,
          createdBy: item.createdBy ? item.createdBy : 1,
          active: item?.isActive ? true : false,
        });
        setDisableCategoryDropdown(false);
        setDisableFamilyDropdown(false);
        setDisableBrickDropdown(false);
        setDisableModelDropdown(false);
        setFormData({ ...item });
        setOpenDialog(true);
      })
    })


  };

  const onClearClick = async () => {
    setSelected([]);
    setDisbaleUpdateButton(true);
    setBrandSearch(null);
    setBrickSearch(null);
    setbrandSearch_(null);
    setcategorySearch_(null);
    setfamilySearch_(null);
    setbrickSearch_(null);
    settypeSearch_(null);
    setmodelSearchValue_(null);
    settechDocSearch_(null);
    const requestBody = {
      pageNumber: 0,
      pageSize: rowsPerPage ?? 10,

    };

    await onSearchServiceAdvisoryDetails(requestBody);
    // await fetchServiceAdvisoryDetails("advisoryNumber", true);
    // onBrandClick();
    setModelNameSearch("");
    setTechDocNameSearch("");
    setCategorySearch(null);
    setTypeSearch(null);
    // onBrickClick();
    setFamilySearch(null);
    fetchCatSearchDropdownList();
    fetchBrandSearchDropdownList();
    fetchFamSearchDropdownList();
    fetchBrickSearchDropdownList();
    setdisableFilterButton(true);
    setDisableSearchButton(true);
    setIsSearchBtnClick(false)
    setPage(0);
    setMaxPage(0);
    // setRowsPerPage(10);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;
  const emptyRows =
    page > 0
      ? Math.max(0, (1 + page) * rowsPerPage - techDocumentRecords.length)
      : 0;

  const handleClickOpenBrandDialog = () => {
    setExistingFiles([]);
    setMultiModelId([]);
    setModelDescription([]);
    fetchAllBrandsList();
    setOpenDialog(true);
    setModelIdData([]);
    setDeptIdData([]);
    setDisableCategoryDropdown(true);
    setDisableFamilyDropdown(true);
    setDisableBrickDropdown(true);
    setDisableModelDropdown(true);
  };

  const handleCloseUploadDialog = () => {
    setExistingFiles([]);
    setMultiModelId([]);
    setModelDescription([]);
    setOpenDialog(false);
    setIsAddServAdv(false);
    setIsEditMode(false);
    setFormData({});
    setFile(null);
    setDraftCheck(false);
    setReleaseDate(null);
    setDeptIdData([]);
  };

  const onSelectModel = (modelId) => {
    fetchModelDescriptionOnSelectedModel(modelId);
    setModelId(modelId);
  };

  const onBrandSelect = (id) => {
    setBrandId(id);
    fetchBrickListOnSelectedBrandForUpload(id);
    setDisableBrickDropdown(false);
  };

  const onBrickSelect = (id) => {
    fetchModelsList(id, brandId);
    setDisableModelDropdown(false);
  };

  const onUploadSubmit = async (data) => {
    if (file === null || file.length === 0) {
      showNotification("Error", "Please select file", "error");
      return;
    }

    var d = new Date();
    d.setHours(0, 0, 0, 0);
    if (!draftCheck) {
      if (isEditMode) {
        if (releaseDate === null) {
          setCurrentError("This field is required");
          setErrorDate(true);
          return;
        }
        else if (releaseDate < d) {
          setCurrentError("Please select Valid release date");
          setErrorDate(true);
          return;
        }
      }
      else {
        if (releaseDate === null) {
          setCurrentError("This field is required");
          setErrorDate(true);
          return;
        }
      }
    }

    try {
      let modelIDs = selectedModelIds.map((id) => {
        return id.modelId;
      });
      if (modelIDs.length <= 0) {
        showNotification(
          "Error",
          "Please select model",
          "error"
        );
        return;
      }
      let deptIDs = selectedDeptIds.map((id) => {
        return id.departmentId;
      });
      if (deptIDs.length <= 0) {
        showNotification(
          "Error",
          "Please select department",
          "error"
        );
        return;
      }
      setLoading(true);

      const param = {
        advisoryNumber: data.advisoryNumber,
        modelId: modelIDs,
        deptId: deptIDs,
        releaseDate: draftCheck ? "" : moment(releaseDate).format("DD-MM-YYYY"),
        createdBy: auth?.ldapParam?.userId,
        isDownloadAble: data.isDownloadAble,
        sendNotification,
        isDrafted: draftCheck,
        notificationDes: data.notificationDes && data.notificationDes.trim(),
        id: data.id,
        docTypeId: data.typeId,
        serviceAdvDesc: data.serviceAdvDesc ? data.serviceAdvDesc.trim() : null,
        oldAdvisoryNumber: formData?.advisoryNumber,
        userDeptId: userDept
      };

      if (file) {
        let tFileSize = 0;

        for (const f of file) {
          const fileName = f?.name;
          var ext = fileName.substr(fileName.lastIndexOf(".") + 1);
          const isRightFormat = filesFormats.includes(f && ext);
          if (!isRightFormat) {
            showNotification(
              "Error",
              "You can only upload pdf, docx/doc, ppt/pptx, xlsx/xls/csv",
              "error"
            );
            return;
          }
          tFileSize = tFileSize + f.size;
        }

        if (tFileSize >= 10485760) {
          showNotification(
            "Error",
            "File too Big, please select files less than 10mb"
          );
          return;
        }
      }
      const uploadResponse = !isEditMode
        ? await UploadServiceAdvisoryDetails(file, param)
        : await UpdateServiceAdvisoryDetails(file, param);
      if (uploadResponse.statusCode === 6) {
        handleCloseUploadDialog();
        //fetchServiceAdvisoryDetails("advisoryNumber", true);
        reset();
        setSendNotification(false);
        setFile(null);
        setDisableFamilyDropdown(true);
        setDisableBrickDropdown(true);
        setDisableModelDropdown(true);
        setSelected([]); setDisbaleUpdateButton(true);
        showNotification("Success", uploadResponse.message, "success");
        onClearClick()
      } else {
        showNotification("Error", uploadResponse.message, "error");
      }
    } catch (err) {
      console.log("errrr", err);
      showNotification("Error", err?.message ?? "Failed to upload");
    } finally {
      setLoading(false);
    }
  };

  //Download service advisory
  const handleDownload = async (id) => {
    try {
      setLoading(true);
      const response = await DownloadServiceAdvisoryService(id);
      if (response) {
        const content = response.headers["content-type"];
        const [, filename] = response.headers['content-disposition'].split('filename=');
        const withoutFirstAndLast = filename.slice(1, -1);
        download(response.data, withoutFirstAndLast, content);
        showNotification("Success", "Succesfully Downloaded", "success");
      } else {
        showNotification("Error", response?.message ?? "Failed to download");
      }
    } catch (err) {
      console.log("err", err);

      showNotification("Error", "Failed to download");
    } finally {
      setLoading(false);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    setSelected([]);
    setDisbaleUpdateButton(true)
    fetchServiceAdvisoryDetails(
      property,
      isAsc,
      brandSearch_, categorySearch_, familySearch_, brickSearch_, typeSearch_, modelSearchValue_, techDocSearch_, rowsPerPage
    );
    setSortValue(isAsc ? "DESC" : "ASC");
    setPage(0);
    setMaxPage(0);
  };

  // To change the value of send notification checkbox
  const handleChange = (event) => {
    setSendNotification(event.target.checked);
  };
  // To change the value of send notification checkbox
  const handleChangeDraft = (event) => {
    setDraftCheck(event.target.checked);
    setReleaseDate(null);
    // setIsDraftChecked()
  };

  return (
    <>
      <Container maxWidth="lg" sx={{ mt: 6 }}>
        <Grid container spacing={2} sx={{ px: 0, mt: 1 }} >
          <Grid item xs={8} sx={{ mb: 1 }}>
            <Typography
              align="left"
              sx={{ mr: "auto", color: "#003f93" }}
              variant="h6">
              {state ? (
                <IconButton sx={{ color: "#567aac" }}>
                  <ArrowBackIcon
                    onClick={() =>
                      navigate(`/notifications`, {
                        state: {
                          // content: response,
                          isUnRead: true,
                          // sorting: true,
                          pageNo: state?.pageNo,
                          typeId: state?.typeId,
                          isFromRead: state?.isFromRead,
                        },
                      })
                    }
                  />
                </IconButton>
              ) : (
                ""
              )}
              Service Advisory ( {totalElements ? totalElements : 0} )
            </Typography>
          </Grid>
          <Grid item xs={4} sx={{ mb: 1 }}>
            {state && state.isUnRead ? (
              ""
            ) : (
              <Grid item xs={12} sx={{ mb: 1 }}>
                <Typography align="right">
                  {advisoriesAccessRights.addDelete ? (
                    <Tooltip title="Update  Status">
                      <Button
                        variant="contained"
                        sx={{ ml: 1 }}
                        className="button-primary-alt-contained"
                        onClick={onChangeStatusSubmit}
                        disabled={disableUpdateButton}>
                        Status Update
                        {selected.length !== 0 &&
                          ` (${Object.keys(selected).length})`}
                      </Button>
                    </Tooltip>
                  ) : null}
                  {advisoriesAccessRights.write ? (
                    <Tooltip title="Upload">
                      <Button
                        variant="contained"
                        startIcon={<FileUploadIcon />}
                        sx={{ ml: 2, textTransform: "initial" }}
                        onClick={handleClickOpenBrandDialog}>
                        Upload
                      </Button>
                    </Tooltip>
                  ) : null}
                </Typography>
              </Grid>
            )}
          </Grid>

          {state?.isUnRead ? (
            ""
          ) : (
            <Grid item >
              <Typography align="right">
                <div className="searchContainer">
                  <FormControl
                    sx={{ m: 0, minWidth: 150, maxWidth: 160, ml: 0 }}
                    size="small">
                    <InputLabel
                      id="demo-simple-select-label"
                      shrink={
                        brandSearch === null || (brandSearch !== null && true)
                      }>
                      <span className="searchFields"> Brand</span>
                    </InputLabel>
                    <Select
                      name="id"
                      label="Brand"
                      autoComplete="off"
                      value={brandSearch}>
                      {brandDropDownList &&
                        brandDropDownList.map((d) => {
                          return (
                            <MenuItem
                              native
                              key={d.id}
                              onClick={() => onBrandClick(d.id)}
                              sx={{ width: "100%" }}
                              value={d.id}
                              size="small">
                              {d.name}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                </div>
              </Typography>
            </Grid>
          )}

          {state?.isUnRead ? (
            ""
          ) : (
            <Grid item xs={2} md={2} sx={{ mb: 1 }}>
              <Typography align="right">
                <div className="searchContainer">
                  <FormControl
                    sx={{ m: 0, minWidth: 150, maxWidth: 160 }}
                    size="small">
                    <InputLabel
                      id="demo-simple-select-label"
                      shrink={
                        categorySearch === null ||
                        (categorySearch !== null && true)
                      }>
                      <span className="searchFields"> Category </span>
                    </InputLabel>
                    <Select
                      name="id"
                      label="Category"
                      autoComplete="off"
                      value={categorySearch}>
                      {categoryList &&
                        categoryList.map((d) => {
                          return (
                            <MenuItem
                              native
                              key={d.id}
                              onClick={() => onCategoryClick(d.id)}
                              sx={{ width: "100%" }}
                              value={d.id}
                              size="small">
                              {d.name}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                </div>
              </Typography>
            </Grid>
          )}

          {state?.isUnRead ? (
            ""
          ) : (
            <Grid item xs={2} md={2} sx={{ mb: 1 }}>
              <Typography align="right">
                <div className="searchContainer">
                  <FormControl
                    sx={{ m: 0, minWidth: 150, maxWidth: 160 }}
                    size="small">
                    <InputLabel
                      id="demo-simple-select-label"
                      shrink={
                        familyName === null || (familyName !== null && true)
                      }>
                      <span className="searchFields"> Family </span>
                    </InputLabel>
                    <Select
                      name="id"
                      label="Family"
                      autoComplete="off"
                      value={familySearch}>
                      {familyList &&
                        familyList.map((d) => {
                          return (
                            <MenuItem
                              native
                              key={d.id}
                              onClick={() => onFamilySerachClick(d.id)}
                              sx={{ width: "100%" }}
                              value={d.id}
                              size="small">
                              {d.name}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                </div>
              </Typography>
            </Grid>
          )}

          {state?.isUnRead ? (
            ""
          ) : (
            <Grid item xs={2} md={2} sx={{ mb: 1 }}>
              <Typography align="right">
                <div className="searchContainer">
                  <FormControl
                    sx={{ m: 0, minWidth: 150, maxWidth: 160 }}
                    size="small">
                    <InputLabel
                      id="demo-simple-select-label"
                      shrink={
                        brickSearch === null || (brickSearch !== null && true)
                      }>
                      <span className="searchFields"> Brick </span>
                    </InputLabel>
                    <Select
                      name="id"
                      label="Brick"
                      autoComplete="off"
                      value={brickSearch}>
                      {brickDropdownList &&
                        brickDropdownList.map((d) => {
                          return (
                            <MenuItem
                              native
                              key={d.categoryId}
                              onClick={() => onBrickSearchClick(d.id)}
                              sx={{ width: "100%" }}
                              value={d.id}
                              size="small">
                              {d.name}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                </div>
              </Typography>
            </Grid>
          )}

          {state?.isUnRead ? (
            ""
          ) : (
            <Grid item xs={2} md={2} sx={{ mb: 1 }}>
              <Typography>
                <FormControl
                  sx={{ m: 0, minWidth: 150, maxWidth: 160 }}
                  size="small">
                  <InputLabel
                    id="demo-simple-select-label"
                    shrink={
                      typeSearch === null || (typeSearch !== null && true)
                    }>
                    <span className="searchFields"> Type </span>
                  </InputLabel>
                  <Select
                    name="id"
                    label="Type"
                    autoComplete="off"
                    value={typeSearch}>
                    {docTypeList &&
                      docTypeList.map((d) => {
                        return (
                          <MenuItem
                            native
                            key={d.id}
                            onClick={() => onTypeClick(d.id)}
                            sx={{ width: "100%" }}
                            value={d.id}
                            size="small">
                            {d.description}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
              </Typography>
            </Grid>
          )}
          {state?.isUnRead ? (
            ""
          ) : (
            <Grid item xs={2} md={2} sx={{ mb: 1 }}>
              <Typography>
                <FormControl
                  sx={{ m: 0, minWidth: 150, maxWidth: 160 }}
                  size="small">
                  <TextField
                    className="stepperFormInput"
                    label="Model Name"
                    onChange={searchText}
                    InputLabelProps={{ shrink: true }}
                    value={modelSearchValue}
                    size="small"
                    autoComplete="off"
                  />
                </FormControl>
              </Typography>
            </Grid>
          )}
          {state?.isUnRead ? (
            ""
          ) : (
            <Grid item >
              <Typography>
                <FormControl
                  sx={{ m: 0, minWidth: 150, maxWidth: 120, ml: 0 }}
                  size="small">
                  <TextField
                    className="stepperFormInput"
                    label="Adv no./Desc"
                    onChange={searchTechDocText}
                    InputLabelProps={{ shrink: true }}
                    value={techDocNameSearch}
                    size="small"
                    autoComplete="off"
                  />
                </FormControl>
              </Typography>
            </Grid>
          )}
          {state?.isUnRead ? (
            ""
          ) : (
            <Tooltip title="Search" sx={{ m: 0, minWidth: 80, maxWidth: 0, ml: 0 }}>
              <IconButton
                color="primary"
                aria-label="Search"
                component="label"
                disabled={disableSearchButton}>
                <SearchIcon
                  sx={{ height: "35px", width: "35px" }}
                  onClick={() => searchOnClick("name")}
                />
              </IconButton>
            </Tooltip>
          )}
          {state?.isUnRead ? (
            ""
          ) : (
            <Tooltip title="Clear Search">
              <IconButton
                color="primary"
                aria-label="Clear"
                component="label"
                disabled={disableFilterButton}>
                <FilterAltOffSharpIcon
                  sx={{ height: "32px", width: "32px" }}
                  onClick={() => onClearClick()}
                />
              </IconButton>
            </Tooltip>
          )}
          <Grid item xs={12} mb={4} >
            <Paper elevation={3} variant="elevation">
              <TableContainer sx={{ height: "100%" }}>
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  aria-labelledby="tableTitle"
                  size="small">
                  <EnhancedTableHead
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    order={order}
                    orderBy={orderBy}
                    loginParam={loginParam}
                    sorting={state?.sorting}
                    state={state}
                  />
                  {searchedRows && searchedRows.length > 0 ? (
                    <TableBody sx={{ mt: 2 }}>
                      {searchedRows
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => {
                          const isItemSelected = isSelected(row.id);
                          const labelId = `enhanced-table-checkbox-${index}`;
                          const isTdRequired = row.isTdRequired;
                          return (
                            <TableRow
                              hover
                              role="checkbox"
                              tabIndex={-1}
                              key={row.userId}
                              onMouseOver={(event) => checkStyle(event, 1)}
                              onMouseOut={(event) => checkStyle(event, 2)}>
                              {isTdRequired ? (
                                <TableCell
                                  rowSpan={row.size}
                                  size="medium"
                                  key={"advisoryNumber"}>
                                  {`${row["advisoryNumber"]}` ?? "-"}:{" "}
                                  {`${row["serviceAdvDesc"]}` === "null"
                                    ? ""
                                    : `${row["serviceAdvDesc"]}`}
                                </TableCell>
                              ) : (
                                ""
                              )}

                              <TableCell size="medium" key={"brandName"}>
                                {`${row["brandName"]}` ?? "-"}
                              </TableCell>
                              <TableCell size="medium" key={"categoryName"}>
                                {`${row["categoryName"]}` ?? "-"}
                              </TableCell>
                              {/* <TableCell
                                size="medium"
                                key={"productFamilyName"}>
                                {`${row["productFamilyName"]}` ?? "-"}
                              </TableCell>
                              <TableCell size="medium" key={"brickName"}>
                                {row["brickName"] ?? "-"}
                              </TableCell> */}
                              <TableCell
                                size="medium"
                                key={"name"}
                                title={row?.description ? row.description : ""}>
                                {row["name"] ?? "-"}-{" "}
                                {(row.description &&
                                  row.description?.slice(0, 25)) ||
                                  "-"}
                                {row.description && row.description.length > 25
                                  ? "..."
                                  : ""}{" "}
                              </TableCell>

                              {/* <TableCell
                                size="medium"
                                key={"docTypeDescription"}>
                                {`${row["docTypeDescription"]}` ?? "-"}
                              </TableCell> */}

                              <TableCell
                                size="medium"
                                key={"createdByFirstName"}>
                                {row["createdByFirstName"] ?? "-"}{" "}
                                {row["createdByLastName"] ?? ""}
                              </TableCell>

                              <TableCell size="medium" key={"releaseDate"}>
                                {`${row["releaseDate"]}` ?? "-"}
                              </TableCell>

                              {isTdRequired ? (
                                <TableCell align="center" rowSpan={row.size}>
                                  {advisoriesAccessRights.addDelete ? (
                                    <Checkbox
                                      color="primary"
                                      checked={(isItemSelected, row.isActive)}
                                      classes={{ root: "custom-checkbox-root" }}
                                      onClick={(event) =>
                                        handleActiveChange(event, row.id)
                                      }
                                      inputProps={{
                                        "aria-labelledby": labelId,
                                      }}
                                    />
                                  ) : null}
                                </TableCell>
                              ) : (
                                ""
                              )}
                              {isTdRequired ? (
                                <TableCell
                                  width="1%"
                                  align="center"
                                  size="medium"
                                  key={"Action"}
                                  rowSpan={row.size}
                                >
                                  <MoreVertIcon
                                    onClick={(event) => {
                                      handleMenuClick(event, row);
                                    }}
                                    fontSize="small"
                                    cursor="pointer"
                                    sx={{ cursor: "pointer", color: "#567aac" }}
                                  />
                                  <Menu
                                    id="service-adv-actions-menu"
                                    className="listingPopOver"
                                    anchorEl={anchorEl}
                                    open={open}
                                    onClose={handleCloseMenu}
                                    MenuListProps={{
                                      "aria-labelledby": "service-adv-actions-button",
                                    }}
                                  >
                                    {advisoriesAccessRights.write && (
                                      <MenuItem onClick={() => handleMenuItem("edit")}>
                                        <EditIcon
                                          fontSize="medium"
                                          color="disabled"
                                          sx={{ mr: 1 }}
                                        />
                                        Edit
                                      </MenuItem>
                                    )}
                                    {loginParam.rilUser && (
                                      <MenuItem
                                        disabled={!selectedRowForMenu?.isDownloadable}
                                        onClick={() => handleMenuItem("download")}
                                      >
                                        <FileDownloadIcon
                                          fontSize="medium"
                                          color="disabled"
                                          sx={{ mr: 1 }}
                                        />
                                        Download
                                      </MenuItem>
                                    )}
                                    {(loginParam?.userType === "Main Admin" ||
                                      loginParam?.userType === "Domain Admin") &&
                                      advisoriesAccessRights.addDelete && (
                                      <MenuItem onClick={() => handleMenuItem("delete")}>
                                        <DeleteIcon
                                          fontSize="medium"
                                          color="disabled"
                                          sx={{ mr: 1 }}
                                        />
                                        Delete
                                      </MenuItem>
                                    )}
                                  </Menu>
                                </TableCell>
                              ) : (
                                ""
                              )}
                            </TableRow>
                          );
                        })}
                      {emptyRows > 0 && (
                        <TableRow
                          style={{
                            height: 33 * emptyRows,
                          }}>
                          <TableCell colSpan={6} />
                        </TableRow>
                      )}
                    </TableBody>
                  ) : (
                    <TableBody>
                      <TableRow>
                        {noRecord ? (
                          <TableCell colSpan={12}>
                            <RecordNotFound />
                          </TableCell>
                        ) : (
                          <TableCell colSpan={6} />
                        )}
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
              {!state?.isUnRead && searchedRows && searchedRows.length > 0 ? (
                <TablePagination
                  className="newPagination"
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  component="div"
                  count={totalElements}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              ) : null}
            </Paper>
            <UploadServiceAdvisory
              openDialog={openDialog}
              handleClose={handleCloseUploadDialog}
              register={register}
              handleSubmit={handleSubmit}
              errors={errors}
              onUploadSubmit={onUploadSubmit}
              allBrands={allBrands}
              modelList={modelList}
              onSelectModel={onSelectModel}
              modelDescription={modelDescription}
              setValue={setValue}
              releaseDate={releaseDate}
              setReleaseDate={setReleaseDate}
              setFile={setFile}
              onBrandSelect={onBrandSelect}
              brickListForUpload={brickListForUpload}
              onBrickSelect={onBrickSelect}
              sendNotification={sendNotification}
              draftCheck={draftCheck}
              handleChange={handleChange}
              disableBrickDropdown={disableBrickDropdown}
              disableModelDropdown={disableModelDropdown}
              setModelDescription={setModelDescription}
              setMultiModelId={setMultiModelId}
              isAddServAdv={isAddServAdv}
              formData={formData}
              brandId={brandId}
              isEditMode={isEditMode}
              isTouched={isTouched}
              isDirty={isDirty}
              brickList={brickList}
              onBrandSelectedClick={onBrandSelectedClick}
              disableCategoryDropdown={disableCategoryDropdown}
              disableFamilyDropdown={disableFamilyDropdown}
              onCategoryClickInModel={onCategoryClickInModel}
              productFamilyList={productFamilyList}
              categoryListOnBrandId={categoryListOnBrandId}
              onFamilyClick={onFamilyClick}
              clearErrors={clearErrors}
              setSelectedModelIds={setSelectedModelIds}
              setSelectedDeptlIds={setSelectedDeptlIds}
              docTypeList={docTypeList}
              departmentList={departmentList}
              handleChangeDraft={handleChangeDraft}
              file={file}
              deptIdData={deptIdData}
              selectedModelIds={selectedModelIds}
              selectedDeptIds={selectedDeptIds}
              modelIdData={modelIdData}
              setCurrentError={setCurrentError}
              setErrorDate={setErrorDate}
              currentError={currentError}
              errorDate={errorDate}
              existingFiles={existingFiles}

            />
          </Grid>
        </Grid>
        <Dialog
          open={confirmDeleteOpen}
          onClose={handleCloseDeleteConfirm}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle
            sx={{ bgcolor: "primary.main", color: "primary.contrastText", py: 1.5 }}
          >
            Confirm Delete
          </DialogTitle>
          <DialogContent dividers>
            Are you sure you want to delete this service advisory?
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDeleteConfirm} variant="outlined">
              Cancel
            </Button>
            <Button
              onClick={() => rowToDelete && handleDeleteAdvisory(rowToDelete)}
              variant="contained"
              color="error"
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </>
  );
}

function EnhancedTableHead({
  onRequestSort,
  order,
  orderBy,
  loginParam,
  sorting,
  state,
}) {
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow key={"1"}>
        {SERVICE_ADVISORY_LISTING_COLUMNS.map((headCell) => (
          <TableCell
            size="small"
            variant="head"
            className="tableHeader"
            sx={{ pt: 1.5, pb: 1.5 }}
            key={headCell.userId}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            style={{
              minWidth: headCell.minWidth,
              fontWeight: "bold",
              color: "#003A6B",
            }}
            sortDirection={orderBy === headCell.id ? order : false}>
            <TableSortLabel
              active={sorting ? false : orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              disabled={
                state ||
                ((headCell.id === "action" || headCell.id === "active") && true)
              }
              hideSortIcon={true}
              hidden={
                loginParam.rilUser === false
                  ? headCell.id === "action"
                    ? true
                    : false
                  : false
              }>
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>{" "}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
